import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import ContactForm from './ContactForm';

export default function CTASection() {
  return (
    <section className="py-24 px-6 relative" id="contact">
      <div className="max-w-7xl mx-auto">
        <div className="relative overflow-hidden rounded-3xl reveal">
          {/* Background Image */}
          <div className="absolute inset-0">
            <AppImage
              src="https://images.unsplash.com/photo-1596980787832-29e21ef1cb8c"
              alt="Professional photographer with camera equipment in atmospheric studio setting with dramatic lighting"
              className="w-full h-full object-cover"
            />

            <div className="absolute inset-0 bg-gradient-to-r from-background via-background/80 to-background/60" />
          </div>

          {/* Content */}
          <div className="relative z-10 py-16 md:py-24 px-6 md:px-12 grid lg:grid-cols-2 gap-12 items-center">
            <div className="max-w-2xl space-y-8">
              <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight">
                Ready to Create
                <br />
                <span className="text-muted-foreground">Something Beautiful?</span>
              </h2>

              <p className="text-lg text-muted-foreground leading-relaxed">
                Let's capture your moments with professional photography that tells your unique
                story.
              </p>

              <div className="flex flex-wrap gap-4">
                <Link
                  href="/gallery"
                  className="px-8 py-4 bg-white text-background rounded-lg font-medium hover:bg-white/90 transition-all duration-300 hover:-translate-y-1"
                >
                  View Portfolio
                </Link>
                {/* <a
                  href="tel:+16471234567"
                  className="px-8 py-4 border border-white/20 rounded-lg font-medium text-white hover:bg-white hover:text-background transition-all duration-300 flex items-center gap-2">
                  
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="currentColor"
                    className="w-5 h-5">
                    
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                    
                  </svg>
                  Call Now
                </a> */}
              </div>
            </div>

            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
}
